<template>
	<div class="page">
		<header>
			<h1>
				Recevoir mon
				<br />étude
			</h1>
		</header>
		<div class="estimation">
			<div class="gauche">Nous vous envoyons par email une étude préliminaire du coût global d'un projet de construction.</div>
			<div class="droite">
				<form id="myform" @submit.prevent="handleSubmit()">
					<div class="line">
						<input type="text" v-model="nom" placeholder="Nom" required maxlength="20" @change="changeInput" />
					</div>
					<div class="line">
						<input type="text" v-model="prenom" placeholder="Prénom" required maxlength="20" @change="changeInput" />
					</div>
					<div class="line full">
						<input type="text" v-model="adresse" placeholder="Adresse" required maxlength="60" @change="changeInput" />
					</div>
					<div class="line one">
						<input type="number" v-model="cp" placeholder="Code postal" required maxlength="6" @change="changeInput" />
					</div>
					<div class="line third">
						<input type="text" v-model="ville" placeholder="Ville" required maxlength="30" @change="changeInput" />
					</div>
					<div class="line">
						<input type="email" v-model="email" placeholder="Email" required maxlength="30" @change="changeInput" />
					</div>
					<div class="line">
						<input type="number" v-model="telephone" placeholder="Téléphone" required maxlength="13" @change="changeInput" />
					</div>
					<div class="line full radio">
						<h4 for="terrain">Terrain</h4>
						<div class="radios">
							<div class="line">
								<input type="radio" name="terrain" id="acquis" v-model="possedeterrain" value="Acquis" @change="changeInput" />
								<label for="acquis">Acquis</label>
							</div>
							<div class="line">
								<input type="radio" name="terrain" id="encours" v-model="possedeterrain" value="En cours" @change="changeInput" />
								<label for="encours">En cours d'acquisition</label>
							</div>
							<div class="line">
								<input type="radio" name="terrain" id="recherche" v-model="possedeterrain" value="En recherche" @change="changeInput" />
								<label for="recherche">En recherche</label>
							</div>
						</div>
					</div>
					<div class="line full radio">
						<h4 for="accompagment">Désirez-vous un accompagment pour votre financement ?</h4>
						<div class="radios">
							<div class="line">
								<input type="radio" name="accompagnement" id="accoui" v-model="accompagnement" value="Oui" @change="changeInput" />
								<label for="accoui">Oui</label>
							</div>
							<div class="line">
								<input type="radio" name="accompagnement" id="accnon" v-model="accompagnement" value="Non" @change="changeInput" />
								<label for="accnon">Non</label>
							</div>
						</div>
					</div>
					<div class="line final">
						<button v-if="acceptance" type="submit"><span>Recevoir mon</span>Estimation</button>
						<button v-else type="submit" disabled><span>Recevoir mon</span>Estimation</button>
						<div class="acceptance">
							<label for="acceptance">En soumettant ce formulaire, j'accepte que les informations saisies soient exploitées dans le cadre de la demande de rappel et de la relation commercial qui peut en découler.</label>
						</div>
					</div>
				</form>
			</div>
		</div>
		<div id="page_preview" ref="print">
			<div class="top">
				<div class="logo">
					<img src="../assets/logo-a4.png" />
				</div>
				<div class="infos">
					<strong>Étude préliminaire d'un projet de construction réalisée le {{ display_date }} pour</strong>
					<br />
					<br />
					<strong>{{ prenom }} {{ nom }}</strong>
					<br />
					{{ adresse }}
					<br />
					{{ cp }}, {{ ville }} <br />-----
					<br />
					Mail : {{ email }}
					<br />
					Tél : {{ telephone }} <br />-----
					<br />
					Terrain {{ possedeterrain }} & {{ $store.state.terrain }}
					<br />
					<span v-if="accompagnement">Accompagnement pour offre de financement souhaitée</span>
				</div>
			</div>
			<div class="centre">
				<div class="presentation">
					<span>Cette étude préliminaire a pour but de vous donner à titre indicatif une estimation du coût global de votre projet de construction.</span>
					<br />
					<br />Le cout de construction estimé de votre projet est réalisé sur la base de ratios connus au moment de la réalisation de cette étude. Ces prix peuvent être amené à être modifiés en fonction de la conjoncture économique, mais également de votre lieu de construction.
					<br />
					<br />Le cout indiqué correspond au coût de construction d’une maison Passive définie par les critères du Passiv’Haus Institut, réalisée dans une démarche hautement qualitative, en ossature bois, matériaux bio-sourcés, Isolation fibre de bois, menuiseries bois aluminium
					triple vitrage certifiées passives, ventilation double flux passive.
					<br />
					<br />La prestation clé en main prévoit une livraison prêt à emménager de votre projet. Les revêtements de sols, le mobilier de salle de bains, les peintures et menuiseries intérieures sont compris. Seuls le mobilier et les équipements de la cuisine ne sont pas inclus à
					ce niveau de prestation. Les matériaux sélectionnés pour la réalisation des prestations de finitions sont choisis dans une gamme de prix médiant, et sont susceptibles d’être revus à la hausse ou à la baisse selon vos choix définitifs.
					<br />
					<br />Par rapport à une prestation clé en main, La prestation Prêt à décorer n’inclue pas les revêtements de sol, le mobilier de salle de bain, les peintures (uniquement la préparation des supports est comprise), les menuiseries intérieures et la cuisine.
					<br />
					<br />Pour finir la prestation Hors d’eau hors d’air est équivalente à une prestation Prêt à décorer sans la réalisation des réseaux secs et humides (électricité, ventilation et sanitaire). Cette prestation inclue néanmoins la réalisation de l’isolation complète du
					projet, les revêtements de façades et brises soleils orientables.
					<br />
					<br />Pour chaque niveau de finition, nous sommes ouvert à toute forme d’aménagement de prestations si votre souhait est de réaliser par vous-même certains lots. Chaque projet fait l’objet de devis détaillés permettant ainsi de vous offrir une transparence économique
					sur chaque poste de dépense.
				</div>
				<div class="content">
					<h3>Estimatif du coût des travaux de construction</h3>
					<li>
						<span>
							Montant estimatif Habitation {{ architecture }} de {{ surface }} m
							<sup>2</sup>
							{{ finition }}
						</span>
						<strong>
							{{ alone_construction }}€
							<sup>TTC</sup>
						</strong>
					</li>
					<li>
						<span>
							Montant estimatif Sous-sol de {{ $store.state.surface_sous_sol }} m
							<sup>2</sup>
						</span>
						<strong>
							{{ final_soussol }}€
							<sup>TTC</sup>
						</strong>
					</li>
					<li>
						<span>Montant estimatif Garage</span>
						<strong>
							{{ final_garage }}€
							<sup>TTC</sup>
						</strong>
					</li>
					<li>
						<span>Montant estimatif Carport</span>
						<strong>
							{{ final_carport }}€
							<sup>TTC</sup>
						</strong>
					</li>
					<li>
						<span>Montant estimatif VRD</span>
						<strong>Non compris</strong>
					</li>
					<hr />
					<h3>Estimatif du coût des dépenses annexes à la construction</h3>
					<h4>Etudes & Interventions externes</h4>
					<li>
						<span>Études sol</span>
						<strong>
							1320,00€
							<sup>TTC</sup>
						</strong>
					</li>
					<li>
						<span>Études Béton armé</span>
						<strong>
							960,00€
							<sup>TTC</sup>
						</strong>
					</li>
					<li>
						<span>Études RT 2012 - Attestation B-BIO</span>
						<strong>
							300,00€
							<sup>TTC</sup>
						</strong>
					</li>
					<li>
						<span>Études RT 2012 - Attestation de fin de chantier</span>
						<strong>
							360,00€
							<sup>TTC</sup>
						</strong>
					</li>
					<li>
						<span>Test infiltrométrie Phase Finale</span>
						<strong>
							420,00€
							<sup>TTC</sup>
						</strong>
					</li>
					<h4>Raccordements réseaux - taxes diverses - Assurances</h4>
					<li>
						<span>Assurance Dommage ouvrage</span>
						<strong>
							{{ final_assurance }}€
							<sup>TTC</sup>
						</strong>
					</li>
					<li>
						<span>Raccordements ERDF, eau potable, téléphone, gaz, taxes aménagement, archéologie</span>
						<strong>Non compris</strong>
					</li>
					<h4>Maîtrise d'Oeuvre</h4>
					<div class="wrapper">
						<div class="colonne">
							<li>
								<span>Ouverture administrative du dossier</span>
								<strong>
									{{ final_mo1 }}€
									<sup>TTC</sup>
								</strong>
							</li>
							<li>
								<span>Etudes préliminaires - Esquisses</span>
								<strong>
									{{ final_mo2 }}€
									<sup>TTC</sup>
								</strong>
							</li>
							<li>
								<span>Avant-Projet Sommaire</span>
								<strong>
									{{ final_mo3 }}€
									<sup>TTC</sup>
								</strong>
							</li>
							<li>
								<span>Avant-Projet Définitif</span>
								<strong>
									{{ final_mo4 }}€
									<sup>TTC</sup>
								</strong>
							</li>
							<li>
								<span>Dossier de demande de PC ou de DT</span>
								<strong>
									{{ final_mo5 }}€
									<sup>TTC</sup>
								</strong>
							</li>
							<li>
								<span>Projet de Conception Générale</span>
								<strong>
									{{ final_mo6 }}€
									<sup>TTC</sup>
								</strong>
							</li>
						</div>
						<div class="colonne">
							<li>
								<span>Dossier de Consultation des Entreprises</span>
								<strong>
									{{ final_mo7 }}€
									<sup>TTC</sup>
								</strong>
							</li>
							<li>
								<span>Mise au point des Marchés de Travaux</span>
								<strong>
									{{ final_mo8 }}€
									<sup>TTC</sup>
								</strong>
							</li>
							<li>
								<span>Visa des études d'exécution</span>
								<strong>
									{{ final_mo9 }}€
									<sup>TTC</sup>
								</strong>
							</li>
							<li>
								<span>Direction de l'Exécution des contrats de Travaux</span>
								<strong>
									{{ final_mo10 }}€
									<sup>TTC</sup>
								</strong>
							</li>
							<li>
								<span>Assistance aux Opérations de Réception</span>
								<strong>
									{{ final_mo11 }}€
									<sup>TTC</sup>
								</strong>
							</li>
							<li>
								<span>Dossier des Ouvrages Exécutés</span>
								<strong>
									{{ final_mo12 }}€
									<sup>TTC</sup>
								</strong>
							</li>
							<li>
								<span>
									<b>Sous-total</b>
								</span>
								<strong>
									{{ final_mo }}€
									<sup>TTC</sup>
								</strong>
							</li>
						</div>
					</div>

					<hr />
					<h3>Récapitulatif</h3>
					<li>
						<span>Coût total des travaux de construction</span>
						<strong>
							{{ total_construction }}€
							<sup>TTC</sup>
						</strong>
					</li>
					<li>
						<span>Coût total des dépenses annexes</span>
						<strong>
							{{ total_annexe }}€
							<sup>TTC</sup>
						</strong>
					</li>
					<li class="big">
						<span>Coût total estimatif de l'opération</span>
						<strong>
							{{ total }}€
							<sup>TTC</sup>
						</strong>
					</li>
					<li class="recap">
						<span>
							Coût total clé en main
							<b>
								{{ total_cem }} €
								<sup>TTC</sup>
							</b>
						</span>
						<span>
							Coût total Prêt à décorer
							<b>
								{{ total_pad }} €
								<sup>TTC</sup>
							</b>
						</span>
						<span>
							Coût total Hors d'eau / Hors d'air
							<b>
								{{ total_heha }} €
								<sup>TTC</sup>
							</b>
						</span>
					</li>
				</div>
			</div>
			<div class="bottom">
				<div>
					<span>Passiv'Home, 27 rue du Vélodrome, 88200 St-Etienne-les-Remiremont</span>
					<span>03 29 22 55 31 - info@passivhome.fr - www.passivhome-construction.com</span>
				</div>
			</div>
		</div>
		<div id="page_loader">
			<img src="../assets/loader.gif" />
			<span>
				Un instant,
				<br />nous générons votre étude <br />et nous vous l'envoyons par email.
			</span>
		</div>
		<footer>
			<router-link to="/carport" class="button back">
				<i class="fa fa-angle-left"></i>
			</router-link>
		</footer>
	</div>
</template>
<script>
import airtable from "airtable";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import numeral from "numeral";
import moment from "moment";
import { Plugins } from "@capacitor/core";

// Définition des prix HT
const c_cem = 1650;
const c_pad = 1400;
const c_hahe = 1235;
const s_cem = 1500;
const s_pad = 1250;
const s_hahe = 1085;
const u_soussol = 550;
const u_garage = 768;
const u_carport = 400;
const cout_etudes = 2688;
const cout_assurance = 2812.59;
const { Keyboard } = Plugins;

export default {
	name: "Coordonnees",
	components: {},
	data() {
		return {
			display_date: "",
			final_construction: 0,
			total_construction_ht: 0,
			total_construction_ht_cem: 0,
			total_construction_ht_pad: 0,
			total_construction_ht_heha: 0,
			total: 0,
			total_cem: 0,
			total_pad: 0,
			total_heha: 0,
			final_soussol: 0,
			final_garage: 0,
			final_carport: 0,
			final_vrd: 0,
			final_assurance: 0,
			final_assurance_cem: 0,
			final_assurance_pad: 0,
			final_assurance_heha: 0,
			final_etudes: 0,
			final_mo1: 0,
			final_mo2: 0,
			final_mo3: 0,
			final_mo4: 0,
			final_mo5: 0,
			final_mo6: 0,
			final_mo7: 0,
			final_mo8: 0,
			final_mo9: 0,
			final_mo10: 0,
			final_mo11: 0,
			final_mo12: 0,
			final_mo: 0,
			final_mo_cem: 0,
			final_mo_pad: 0,
			final_mo_heha: 0,
			architecture: this.$store.state.architecture,
			finition: this.$store.state.finition,
			surface: this.$store.state.surface,
			surface_sous_sol: this.$store.state.surface_sous_sol,
			nom: this.$store.state.nom,
			prenom: this.$store.state.prenom,
			adresse: this.$store.state.adresse,
			cp: this.$store.state.cp,
			ville: this.$store.state.ville,
			email: this.$store.state.email,
			telephone: this.$store.state.telephone,
			possedeterrain: this.$store.state.possedeterrain,
			accompagnement: this.$store.state.accompagnement,
			acceptance: this.$store.state.acceptance,
			montant_estimatif_travaux: 0,
			montant_estimatif_soussol: 0,
			montant_estimatif_garage: 0,
			montant_estimatif_vrd: 6600,
			conception_architecturale: 0,
			conception_technique: 0,
			chantier: 0,
			total_construction: 0,
			total_annexe: 0,
			total_annexe_cem: 0,
			total_annexe_pad: 0,
			total_annexe_heha: 0,
			format_date: "",
			alone_construction: 0
		};
	},
	methods: {
		changeInput() {
			var data = {
				nom: this.nom,
				prenom: this.prenom,
				adresse: this.adresse,
				cp: this.cp,
				ville: this.ville,
				email: this.email,
				telephone: this.telephone,
				possedeterrain: this.possedeterrain,
				accompagnement: this.accompagnement,
				acceptance: this.acceptance
			};
			this.$store.commit("setCoordonnees", data);
		},
		makeTotal() {
			// Cout du sousol
			this.display_date = moment()
				.locale("fr")
				.format("LL");

			this.final_soussol = this.$store.state.surface_sous_sol * u_soussol;

			// Les totaux pour chaque finition
			this.total_construction_ht_cem += this.final_soussol;
			this.total_construction_ht_pad += this.final_soussol;
			this.total_construction_ht_heha += this.final_soussol;
			// Rendu textuel
			this.final_soussol = numeral(this.final_soussol * 1.2)
				.format("0,0.00")
				.replace(",", " ");

			// Coût du garage
			switch (this.$store.state.garage) {
				case "Non":
					this.final_garage = 0;
					break;
				case "Oui, 1 véhicule":
					this.final_garage = 20 * u_garage;
					break;
				case "Oui, 2 véhicules":
					this.final_garage = 40 * u_garage;
					break;
			}

			// Les totaux pour chaque finition
			this.total_construction_ht_cem += this.final_garage;
			this.total_construction_ht_pad += this.final_garage;
			this.total_construction_ht_heha += this.final_garage;
			// Rendu textuel
			this.final_garage = numeral(this.final_garage * 1.2)
				.format("0,0.00")
				.replace(",", " ");

			// Cout du Carport
			switch (this.$store.state.carport) {
				case "Non":
					this.final_carport = 0;
					break;
				case "Oui, 1 véhicule":
					this.final_carport = 15 * u_carport;
					break;
				case "Oui, 2 véhicules":
					this.final_carport = 30 * u_carport;
					break;
			}
			// Les totaux pour chaque finition
			this.total_construction_ht_cem += this.final_carport;
			this.total_construction_ht_pad += this.final_carport;
			this.total_construction_ht_heha += this.final_carport;
			// Rendu textuel
			this.final_carport = numeral(this.final_carport * 1.2)
				.format("0,0.00")
				.replace(",", " ");

			// Cout du Carport
			//this.final_vrd = cout_vrd;
			//this.total_construction_ht += this.final_vrd;
			//this.final_vrd = numeral(cout_vrd * 1.2).format("0,0.00");
			// Cout construction
			switch (this.$store.state.architecture) {
				case "Complexe":
					this.total_construction_ht_cem += this.$store.state.surface * c_cem;
					this.total_construction_ht_pad += this.$store.state.surface * c_pad;
					this.total_construction_ht_heha += this.$store.state.surface * c_hahe;
					switch (this.$store.state.finition) {
						case "Clés en main":
							this.final_construction = this.total_construction_ht_cem;
							this.alone_construction = this.$store.state.surface * c_cem;
							break;
						case "Prêt à décorer":
							this.final_construction = this.total_construction_ht_pad;
							this.alone_construction = this.$store.state.surface * c_pad;
							break;
						default:
							this.final_construction = this.total_construction_ht_heha;
							this.alone_construction = this.$store.state.surface * c_hahe;
							break;
					}

					break;
				case "Simple":
					this.total_construction_ht_cem += this.$store.state.surface * s_cem;
					this.total_construction_ht_pad += this.$store.state.surface * s_pad;
					this.total_construction_ht_heha += this.$store.state.surface * s_hahe;
					switch (this.$store.state.finition) {
						case "Clés en main":
							this.final_construction = this.total_construction_ht_cem;
							this.alone_construction = this.$store.state.surface * s_cem;
							break;
						case "Prêt à décorer":
							this.final_construction = this.total_construction_ht_pad;
							this.alone_construction = this.$store.state.surface * s_pad;
							break;
						default:
							this.final_construction = this.total_construction_ht_heha;
							this.alone_construction = this.$store.state.surface * s_hahe;
							break;
					}
					break;
			}
			switch (this.$store.state.finition) {
				case "Clés en main":
					this.total_construction_ht += this.total_construction_ht_cem;
					break;
				case "Prêt à décorer":
					this.total_construction_ht += this.total_construction_ht_pad;
					break;
				default:
					this.total_construction_ht += this.total_construction_ht_heha;
					break;
			}

			this.alone_construction = numeral(this.alone_construction * 1.2)
				.format("0,0.00")
				.replace(",", " ");
			this.total_construction = numeral(this.total_construction_ht * 1.2)
				.format("0,0.00")
				.replace(",", " ");
			this.final_construction = numeral(this.final_construction * 1.2)
				.format("0,0.00")
				.replace(",", " ");

			// Cout Etudes
			console.log(this.total_construction_ht);
			this.final_etudes = numeral(cout_etudes * 1.2)
				.format("0,0.00")
				.replace(",", " ");
			this.total_annexe += cout_etudes;
			this.total_annexe_cem += cout_etudes;
			this.total_annexe_pad += cout_etudes;
			this.total_annexe_heha += cout_etudes;

			// Cout MOE
			this.final_mo = this.total_construction_ht * 0.1;
			console.log(this.total_construction_ht);
			this.final_mo_cem = this.total_construction_ht_cem * 0.1;
			this.final_mo_pad = this.total_construction_ht_pad * 0.1;
			this.final_mo_heha = this.total_construction_ht_heha * 0.1;

			this.total_annexe += this.final_mo;
			this.total_annexe_cem += this.final_mo_cem;
			this.total_annexe_pad += this.final_mo_pad;
			this.total_annexe_heha += this.final_mo_heha;

			this.final_mo1 = numeral(this.final_mo * 0.02 * 1.2)
				.format("0,0.00")
				.replace(",", " ");
			this.final_mo2 = numeral(this.final_mo * 0.03 * 1.2)
				.format("0,0.00")
				.replace(",", " ");
			this.final_mo3 = numeral(this.final_mo * 0.05 * 1.2)
				.format("0,0.00")
				.replace(",", " ");
			this.final_mo4 = numeral(this.final_mo * 0.1 * 1.2)
				.format("0,0.00")
				.replace(",", " ");
			this.final_mo5 = numeral(this.final_mo * 0.05 * 1.2)
				.format("0,0.00")
				.replace(",", " ");
			this.final_mo6 = numeral(this.final_mo * 0.15 * 1.2)
				.format("0,0.00")
				.replace(",", " ");
			this.final_mo7 = numeral(this.final_mo * 0.15 * 1.2)
				.format("0,0.00")
				.replace(",", " ");
			this.final_mo8 = numeral(this.final_mo * 0.05 * 1.2)
				.format("0,0.00")
				.replace(",", " ");
			this.final_mo9 = numeral(this.final_mo * 0.02 * 1.2)
				.format("0,0.00")
				.replace(",", " ");
			this.final_mo10 = numeral(this.final_mo * 0.34 * 1.2)
				.format("0,0.00")
				.replace(",", " ");
			this.final_mo11 = numeral(this.final_mo * 0.04 * 1.2)
				.format("0,0.00")
				.replace(",", " ");
			this.final_mo12 = numeral(this.final_mo * 0 * 1.2)
				.format("0,0.00")
				.replace(",", " ");

			// Cout assurances
			this.final_assurance = (this.total_construction_ht + this.final_mo) * 0.018;
			this.final_assurance_cem = (this.total_construction_ht_cem + this.final_mo_cem) * 0.018;
			this.final_assurance_pad = (this.total_construction_ht_pad + this.final_mo_pad) * 0.018;
			this.final_assurance_heha = (this.total_construction_ht_heha + this.final_mo_heha) * 0.018;

			this.total_annexe += this.final_assurance;
			this.total_annexe_cem += this.final_assurance_cem;
			this.total_annexe_pad += this.final_assurance_pad;
			this.total_annexe_heha += this.final_assurance_heha;

			// Total annexe
			var fourchette_moins = (this.total_construction_ht + this.total_annexe) * 1.2 - 10000;
			fourchette_moins = fourchette_moins / 1000;
			fourchette_moins = Math.round(fourchette_moins);
			fourchette_moins = fourchette_moins * 1000;

			var fourchette_plus = (this.total_construction_ht + this.total_annexe) * 1.2 + 10000;
			fourchette_plus = fourchette_plus / 1000;
			fourchette_plus = Math.round(fourchette_plus);
			fourchette_plus = fourchette_plus * 1000;

			this.$store.commit(
				"setFourchette",
				"Entre " +
					numeral(fourchette_moins)
						.format("0,0")
						.replace(",", " ") +
					"€ et " +
					numeral(fourchette_plus)
						.format("0,0")
						.replace(",", " ") +
					"€"
			);
			this.total = numeral((this.total_construction_ht + this.total_annexe) * 1.2)
				.format("0,0.00")
				.replace(",", " ");
			this.total_cem = numeral((this.total_construction_ht_cem + this.total_annexe_cem) * 1.2)
				.format("0,0.00")
				.replace(",", " ");
			this.total_pad = numeral((this.total_construction_ht_pad + this.total_annexe_pad) * 1.2)
				.format("0,0.00")
				.replace(",", " ");
			this.total_heha = numeral((this.total_construction_ht_heha + this.total_annexe_heha) * 1.2)
				.format("0,0.00")
				.replace(",", " ");
			this.final_assurance = numeral(this.final_assurance * 1.2)
				.format("0,0.00")
				.replace(",", " ");
			this.final_mo = numeral(this.final_mo * 1.2)
				.format("0,0.00")
				.replace(",", " ");
			this.total_annexe = numeral(this.total_annexe * 1.2)
				.format("0,0.00")
				.replace(",", " ");
		},
		dataURItoBlob(dataURI) {
			// convert base64/URLEncoded data component to raw binary data held in a string
			var byteString;
			if (dataURI.split(",")[0].indexOf("base64") >= 0) byteString = atob(dataURI.split(",")[1]);
			else byteString = unescape(dataURI.split(",")[1]);

			// separate out the mime component
			var mimeString = dataURI
				.split(",")[0]
				.split(":")[1]
				.split(";")[0];

			// write the bytes of the string to a typed array
			var ia = new Uint8Array(byteString.length);
			for (var i = 0; i < byteString.length; i++) {
				ia[i] = byteString.charCodeAt(i);
			}

			return new Blob([ia], { type: mimeString });
		},
		saveData() {
			var fields = {
				Date: moment().format("YYYY-MM-DD"),
				Salon: "Salon Bois Epinal 2020",
				Nom: this.$store.state.nom,
				Prénom: this.$store.state.prenom,
				Adresse: this.$store.state.adresse,
				CP: this.$store.state.cp,
				Ville: this.$store.state.ville,
				Email: this.$store.state.email,
				Téléphone: this.$store.state.telephone,
				Terrain: this.$store.state.possedeterrain,
				AccompagnementFinancement: this.$store.state.accompagnement,
				Typologie: this.$store.state.terrain,
				Garage: this.$store.state.garage,
				Carport: this.$store.state.carport,
				Architecture: this.$store.state.architecture,
				Surface_Habitable_souhaitée: this.$store.state.surface,
				Finition: this.$store.state.finition,
				Surface_sous_sol: this.$store.state.surface_sous_sol,
				Fourchette_estimative: this.$store.state.fourchette_estimative,
				PDF: this.$store.state.pdf
			};
			var Airtable = require("airtable");
			var base = new Airtable({ apiKey: "keyVJRh82TPHU88xc" }).base("app5Px2lPlgHfQP13");
			base("Inscriptions").create(
				[
					{
						fields: fields
					}
				],
				function(err, records) {
					if (err) {
						return;
					}
					var loader = document.querySelector("#page_loader");
					if (loader) {
						loader.style.display = "none";
					}
				}
			);
			this.$router.push({ path: "/merci" });
		},
		handleSubmit() {
			this.changeInput();
			// Je m'occupe du PDF
			var preview = document.querySelector("#page_preview");
			var loader = document.querySelector("#page_loader");
			loader.style.display = "flex";
			preview.style.display = "block";
			html2canvas(preview, {
				backgroundColor: "#ffffff",
				scale: 2,
				imageTimeout: 30000
			}).then(canvas => {
				preview.style.display = "none";
				var image = canvas.toDataURL("image/jpeg", 1.0);
				var doc = new jsPDF({
					orientation: "p",
					unit: "px",
					format: "a4"
				});
				var width = doc.internal.pageSize.getWidth();
				doc.addImage(image, "JPEG", 0, 0, width, 0);
				var outputBase64 = doc.output("datauristring");
				var preBlob = this.dataURItoBlob(outputBase64);
				var file = new File([preBlob], "etude_preliminaire_" + this.$store.state.nom + "-" + this.$store.state.prenom + ".pdf", {
					type: "application/pdf"
				});
				const data = new FormData();
				data.append("service", "send_email");
				data.append("email", this.email);
				data.append("nom", this.nom);
				data.append("prenom", this.prenom);
				data.append("file", file);
				this.$store.commit("setTimer", 360);
				this.axios.post("https://passivhome-construction.com/api/custom_service/", data).then(response => {
					if (response.data.result.mail == "ok") {
						this.$store.commit("setPdf", response.data.result.url);
						this.saveData();
					}
				});
			});
		}
	},
	mounted() {
		this.makeTotal();
		this.$store.commit("setTimer", 180);
		Keyboard.addListener("keyboardWillShow", info => {
			var myform = document.getElementById("myform");
			myform.classList.add("remonte");
		});
		Keyboard.addListener("keyboardWillHide", info => {
			var myform = document.getElementById("myform");
			myform.classList.remove("remonte");
		});
	},
	computed: {
		ready() {
			if (this.nom != "" && this.prenom != "" && this.adresse != "" && this.cp != "" && this.ville != "" && this.email != "" && this.telephone != "" && this.acceptance == true) {
				return true;
			} else {
				return false;
			}
		}
	}
};
</script>

<style lang="less">
.estimation {
	display: flex;
	padding: 30px;
	.gauche {
		flex: 1;
		color: white;
		font-weight: bold;
		font-size: 20px;
		line-height: 26px;
		padding-right: 50px;
		transform: translateY(-6px);
	}
	.droite {
		flex: 2;
		padding: 0 20px 0 40px;
		border-left: solid 1px black;
		form#myform {
			display: flex;
			flex-wrap: wrap;
			transform: translateY(-10px);
			transition: all 0.3s ease;
			&.remonte {
				transform: translateY(-150px);
				.line {
					padding: 3px;
				}
			}
			.line {
				flex: 0 0 50%;
				padding: 10px;
				input[type="text"],
				input[type="email"],
				input[type="phone"],
				input[type="number"] {
					width: 100%;
					outline: none;
					height: 36px;
					border: none;
					padding: 0 20px;
					font-size: 15px;
					color: black;
					font-weight: bold;
					border-radius: 0px;
				}
				&.full {
					flex: 0 0 100%;
				}
				&.radio {
					display: flex;
					label,
					h4 {
						flex: 0 0 auto;
						font-weight: bold;
						color: black;
						font-size: 15px;
						max-width: 50%;
						padding-right: 30px;
						margin: 0;
					}
					.radios {
						flex: 1;
						font-weight: bold;
						.line {
							padding: 0;
							margin-bottom: 5px;
							display: flex;
							align-items: center;
							input[type="radio"] {
								width: 14px;
								height: 14px;
								appearance: none;
								background: transparent;
								border: solid 1px white;
								margin-right: 10px;
								&:checked {
									background: white;
								}
							}
						}
					}
				}
				&.one {
					flex: 0 0 33.333333%;
				}
				&.third {
					flex: 0 0 66.6666666%;
				}
				&.final {
					display: flex;
					align-items: flex-start;
					justify-content: flex-start;
					flex: 0 0 100%;
					margin-top: 20px;
					button[type="submit"] {
						background: black;
						outline: none;
						border: none;
						padding: 8px 30px;
						background: black;
						color: #c9aa6c;
						font-size: 18px;
						font-weight: bold;
						text-transform: uppercase;
						border-radius: 5px;
						text-decoration: none;
						display: flex;
						flex-direction: column;
						text-align: center;
						justify-content: center;
						align-items: center;
						&:disabled {
							cursor: not-allowed;
							opacity: 0.5;
							background: lighten(black, 50%);
							color: white;
						}
						span {
							font-size: 14px;
							text-transform: none;
						}
					}
					.acceptance {
						padding: 0 0 0 20px;
						flex: 1;
						input[type="checkbox"] {
							width: 14px;
							height: 14px;
							appearance: none;
							background: transparent;
							border: solid 1px white;
							margin-right: 10px;
							&:checked {
								background: white;
							}
						}
						label {
							width: 100%;
							font-size: 12px;
							color: white;
							font-weight: bold;
						}
					}
				}
			}
		}
	}
}
#page_preview {
	padding: 50px;
	background: white;
	font-size: 14px;
	width: 1190px;
	height: 1684px;
	display: none;
	font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
	.top {
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
		.infos {
			text-align: right;
			padding-bottom: 5px;
		}
	}
	.centre {
		display: flex;
		padding-top: 80px;
		padding-bottom: 30px;
		align-items: flex-start;
		overflow: auto;
		.presentation {
			flex: 3;
			padding-right: 20px;
			font-size: 13px;
			font-weight: normal;
			line-height: 17px;
			display: block;
			overflow: auto;
			span {
				font-size: 1.1em;
				color: #c9aa6c;
			}
		}
		.content {
			flex: 7;
			padding-left: 40px;
			hr {
				margin: 15px auto;
				border: none;
				background: lighten(black, 100%);
				height: 1px;
			}
			h3 {
				color: #c9aa6c;
				font-size: 16px;
				margin: 0 0 15px;
			}
			h4 {
				font-size: 13px;
				margin: 20px 0 10px 30px;
			}
			li {
				list-style: none;
				display: flex;
				align-items: flex-end;
				justify-content: space-between;
				padding: 5px 0;
				margin-left: 30px;
				border-bottom: dotted 1px lighten(black, 90%);
				strong {
					font-size: 1em;
					text-align: right;
					flex: 0 0 120px;
				}
				sup {
					font-size: 0.7em;
				}
				&.recap {
					font-size: 0.9em;
					display: flex;
					align-items: center;
					text-align: center;
					span {
						flex: 1;
						b {
							display: block;
						}
					}
				}
				&.big {
					font-size: 1.3em;
					font-weight: bold;
					margin-top: 20px;
					border-top: solid 2px black;
					border-bottom: solid 2px black;
					strong {
						font-size: 1em;
						text-align: right;
						flex: 0 0 160px;
					}
				}
			}
		}
	}
	.bottom {
		color: lighten(black, 50%);
		text-align: center;
		padding-top: 30px;
		display: block;
		overflow: auto;
		span {
			display: block;
			text-align: center;
		}
	}
}
#page_loader {
	position: fixed;
	display: none;
	top: 0;
	left: 0;
	right: 0;
	z-index: 999;
	bottom: 0;
	background: fadeOut(white, 2%);
	backdrop-filter: blur(10px);
	align-items: center;
	justify-content: center;
	text-align: center;
	flex-direction: column;
	font-weight: 400;
	font-size: 24px;
	line-height: 30px;
}
</style>
